import { SITE_COMPONENTS_SERVER_STATICS_FOLDER } from '@wix/cli-app-definitions';
import { mergeConfig } from 'vite';
import type { InlineConfig } from 'vite';
import type { ProjectModel } from '../../../model.js';
import type { ViteBuildConfigOptions } from '../../vite-config-options.js';
import {
  virtualSiteComponentScriptAssets,
  virtualSiteComponentPreviewScriptAssets,
} from '../../../dev-center/components/site/config.js';
import { moduleBundleBuildSiteComponents } from '../../plugins/module-bundle/plugin.js';
import { siteComponentsExternals } from '../shared.js';
import { getBaseViteConfig } from './base.js';

export function getViteConfig(
  model: ProjectModel,
  options: ViteBuildConfigOptions
): InlineConfig[] {
  const virtualSiteComponentScriptEntries = [
    ...virtualSiteComponentScriptAssets(model),
  ].map(
    ([assetId, component]) => [`script-asset-${component.id}`, assetId] as const
  );
  const virtualSiteComponentPreviewScriptEntries = [
    ...virtualSiteComponentPreviewScriptAssets(model),
  ].map(([assetId, component]) => [
    `script-asset-${component.id}-preview`,
    assetId,
  ]);

  return [
    ...virtualSiteComponentScriptEntries,
    ...virtualSiteComponentPreviewScriptEntries,
  ].map(([entryName, entryPath]) => {
    const baseConfig = getBaseViteConfig({
      ...options,
      model,
      outputDir: SITE_COMPONENTS_SERVER_STATICS_FOLDER,
    });

    const config = {
      ssr: {
        target: 'webworker',
        noExternal: true,
      },
      build: {
        ssr: true,
        ssrEmitAssets: true,
        rollupOptions: {
          external: siteComponentsExternals,
          input: {
            [entryName]: entryPath,
          },
          output: {
            inlineDynamicImports: true,
          },
        },
      },
      plugins: [moduleBundleBuildSiteComponents({ initialModel: model })],
    } satisfies InlineConfig;

    return mergeConfig(config, baseConfig);
  });
}
